var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"dtable w100",attrs:{"id":"app"}},[_c('router-view',{}),_c('KeyboardCodeHandler'),_c('HealthChecker'),_c('Modal'),_c('Alert')],1)}
var staticRenderFns = []

export { render, staticRenderFns }